/**
 * @generated SignedSource<<40c3e5f89b30728f4ef8f4211374ea51>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PinningPinMutationInput = {
  clientMutationId?: string | null;
  context: string;
  label?: string | null;
  nodeId: string;
};
export type MarkAsOption_pinNodeMutation$variables = {
  input: PinningPinMutationInput;
};
export type MarkAsOption_pinNodeMutation$data = {
  readonly pin: {
    readonly nodePinned: {
      readonly __typename: string;
      readonly id: string;
      readonly pins?: ReadonlyArray<{
        readonly context: string;
        readonly id: string;
        readonly label: string | null;
      }> | null;
    };
  } | null;
};
export type MarkAsOption_pinNodeMutation = {
  response: MarkAsOption_pinNodeMutation$data;
  variables: MarkAsOption_pinNodeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PinningPinMutationPayload",
    "kind": "LinkedField",
    "name": "pin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodePinned",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Pin",
                "kind": "LinkedField",
                "name": "pins",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "context",
                    "storageKey": null
                  },
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "label",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "HasPinsInterface",
            "abstractKey": "__isHasPinsInterface"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MarkAsOption_pinNodeMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MarkAsOption_pinNodeMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "73ff6e02047e8b18dd923cbf54ba1e50",
    "id": null,
    "metadata": {},
    "name": "MarkAsOption_pinNodeMutation",
    "operationKind": "mutation",
    "text": "mutation MarkAsOption_pinNodeMutation(\n  $input: PinningPinMutationInput!\n) {\n  pin(input: $input) {\n    nodePinned {\n      __typename\n      id\n      ... on HasPinsInterface {\n        __isHasPinsInterface: __typename\n        pins {\n          context\n          id\n          label\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "039387cdadce478813f92e1635d332c4";

export default node;
